import { call, put } from 'redux-saga/effects';
import axios from './axiosHandler';
import { API_HOST } from '../env';
import sagaLoading from './sagaLoading';
import sagaGetAllMeditations from './sagaGetAllMeditations';
import { MESSAGE_ERROR, MESSAGE_SUCCESS } from '../actions/actionTypes';

export default function* sageUpdateMeditation({ data }) {
  const updateData = new FormData();
  // eslint-disable-next-line
  // updateData.set('id', data['_id']);
  updateData.set('name', data.name);
  updateData.set('data', data.data);
  if (data.fileLocation) {
    updateData.append('fileLocation', data.fileLocation);
  }
  try {
    yield call(sagaLoading, true);
    yield call(() =>
      axios({
        url: `${API_HOST}meditation/create`,
        method: 'post',
        data: updateData,
      }).then((response) => response.data)
    );
    yield call(sagaGetAllMeditations);
    yield put({ type: MESSAGE_SUCCESS, payload: 'Updated successfully' });
    yield call(sagaLoading, false);
  } catch (error) {
    // eslint-disable-next-line no-console
    console.log(error);
    yield call(sagaLoading, false);
    yield put({
      type: MESSAGE_ERROR,
      payload: error.message ? error.message : 'There is something wrong, please, try again.',
    });
  }
}
